import { MtgRoomAssignmentCreateRequest } from "../../model/mtgRoomAssignmentCreateRequest";
import { fetchPostJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = MtgRoomAssignmentCreateRequest;

export async function postMeetingRoomAssignments(payload: DtoType) {
  try {
    const url = apiUrls.postSipMeetingRoomAssignments;
    return await fetchPostJSON(url, payload);
  } catch (err) {
    console.error("API Error - postMeetingRoomAssignments:", err);
  }
}
